/* Consentement aux cookies COZYHAVN.
   Le choix est enregistré en local (date comprise) et transmis à Shopify par l'API de confidentialité
   client : statistiques Shopify, pixels et apps attendent ce consentement avant de déposer leurs cookies.
   Au-delà de la durée de conservation (6 mois au plus), le consentement est retiré puis redemandé. */
(() => {
  const banner = document.getElementById('CookieConsent');
  const dialog = document.getElementById('CookiePreferences');
  if (!banner || !dialog) return;

  const KEY = 'cozyhavn:consent';
  const months = Math.min(Number(banner.dataset.consentMonths) || 6, 6);
  const maxAge = months * 30.44 * 24 * 60 * 60 * 1000;
  const NONE = { preferences: false, analytics: false, marketing: false };
  const ALL = { preferences: true, analytics: true, marketing: true };

  const read = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (!stored || typeof stored.date !== 'number') return null;
      return Date.now() - stored.date > maxAge ? { expired: true } : stored;
    } catch (error) {
      return null;
    }
  };

  // Charge l'API de confidentialité client de Shopify si elle n'est pas déjà là.
  const withPrivacyApi = (callback) => {
    const shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) return callback(shopify.customerPrivacy);
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error && window.Shopify.customerPrivacy) callback(window.Shopify.customerPrivacy);
      });
    }
  };

  const transmit = (choice) =>
    withPrivacyApi((api) =>
      api.setTrackingConsent(
        {
          preferences: choice.preferences,
          analytics: choice.analytics,
          marketing: choice.marketing,
          sale_of_data: choice.marketing
        },
        () => {}
      )
    );

  const save = (choice) => {
    const record = { ...NONE, ...choice, date: Date.now() };
    try {
      window.localStorage.setItem(KEY, JSON.stringify(record));
    } catch (error) {
      /* Stockage indisponible : le choix vaut pour cette page. */
    }
    transmit(record);
    banner.hidden = true;
    if (dialog.open) dialog.close();
    document.dispatchEvent(new CustomEvent('cozyhavn:consent', { detail: record }));
  };

  const openPreferences = () => {
    const current = read();
    const choice = current && !current.expired ? current : NONE;
    ['preferences', 'analytics', 'marketing'].forEach((name) => {
      dialog.querySelector(`[name="${name}"]`).checked = Boolean(choice[name]);
    });
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cookie-preferences]')) {
      event.preventDefault();
      openPreferences();
    } else if (event.target.closest('[data-consent-accept]')) {
      save(ALL);
    } else if (event.target.closest('[data-consent-reject]')) {
      save(NONE);
    } else if (event.target.closest('[data-consent-save]')) {
      const form = dialog.querySelector('[data-consent-form]');
      save({
        preferences: form.elements.preferences.checked,
        analytics: form.elements.analytics.checked,
        marketing: form.elements.marketing.checked
      });
    }
  });

  const stored = read();
  if (!stored || stored.expired) {
    // Choix absent ou trop ancien : rien n'est autorisé tant que la personne n'a pas choisi.
    if (stored && stored.expired) transmit(NONE);
    banner.hidden = false;
  }
})();
